import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EventUserActiveReply, User } from '@shared/api/api-loop/models';
import { AutoUnsubscribe } from '../../../shared/utils/subscriptions/auto-unsubscribe';
import {
  WebsocketCardEventsAggregationService,
  WebsocketEventCard
} from '../websocket-card-events-aggregation/websocket-card-events-aggregation.service';
import { HubEventType } from '@dta/shared/models/event.models';

@Injectable()
export class CollisionDetectionService extends WebsocketCardEventsAggregationService {
  constructor() {
    super([HubEventType.EventUserActiveReply]);
  }

  registerCardAndGetActiveUsers(cardId: string): Observable<string> {
    return this.getWebsocketCard(cardId).pipe(
      map((cards: WebsocketEventCard[]) => this.activeUsersToString(cards[0].users))
    );
  }

  private activeUsersToString(users: User[]): string {
    if (!users || users.length === 0) {
      return '';
    }

    let text = users
      .slice(0, 2)
      .map((user: User) => user.name)
      .join(users.length === 2 ? ' and ' : ', ');

    if (users.length > 2) {
      text += ' +' + (users.length - 2);
    }

    text += users.length > 1 ? ' are' : ' is';

    return text;
  }
}
